import moment from "moment";

const date45Days = v => {
  let date = moment(v);
  let today = moment().add("45", "days");
  return date.isSameOrAfter(today);
};

export default date45Days;
